module.exports = __webpack_public_path__ + "img/spencer-davis-QdU9lnBB5RQ-unsplash.d5456c09.jpg";